"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Used to wrap system message actions.
 */


var SystemMessageActions = function SystemMessageActions(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react2.default.createElement("div", {
    className: (0, _classnames2.default)("cdk-system-message__actions", className)
  }, children);
};

SystemMessageActions.propTypes = {
  /** System message actions custom CSS class(es) */
  className: _propTypes.string,

  /** The System message action(s) or actionIcon(s) or custom component(s) */
  children: _propTypes.node
};
exports.default = SystemMessageActions;